export const Entries = {
    of: (obj) => Object.entries(obj),
    toObj: (entries) => Object.fromEntries(entries),
};
//# sourceMappingURL=entries.js.map